import * as React from 'react'

const ScrollToTop = props => {
  return (
    <svg width={50} height={50} viewBox="0 0 50 50" fill="none" {...props}>
      <rect width="50" height="50" fill="#304A3D" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 25L16.393 26.435L24 18.828V35H26V18.828L33.586 26.414L35 25C31.339 21.339 28.504 18.504 25 15C21.034 18.966 23.834 16.166 15 25"
        fill="#E7F74B"
      />
    </svg>
  )
}

export default ScrollToTop
